import React, { useEffect, useRef, useState } from "react";

const Tippopover = ({ tip }) => {
  const popoverRef = useRef();
  const [onTop, setOnTop] = useState(false);

  useEffect(() => {
    const scrollEvent = window.addEventListener(
      "scroll",
      function () {
        const positionInViewport = popoverRef?.current?.getBoundingClientRect();
        const viewportHeight = window.innerHeight;

        const distanceFromBottom = viewportHeight - positionInViewport?.bottom;

        if (distanceFromBottom < 200) {
          setOnTop(true);
        } else {
          setOnTop(false);
        }
      },
      true
    );

    return () => {
      window.removeEventListener("scroll", scrollEvent);
    };
  }, []);

  return (
    <div className={`tooltip-popover ${onTop ? "top" : ""}`} ref={popoverRef}>
      {tip}
    </div>
  );
};

export default Tippopover;
